import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IPInvestigationApi } from '../api/ipinvestigation.api';
import { switchMap, map } from 'rxjs/operators';

import { IPInvestigationData, IPInvestigation } from '../../../interfaces/Ip/ipinvestigation' ;
@Injectable()
export class IPInvestigationService extends IPInvestigationData {

    constructor(private api: IPInvestigationApi) {
      super();
    }
  
  
    list(url: string): Observable<IPInvestigation[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<IPInvestigation>{
        return this.api.getById(url);
    }
  
    create(url: string, data:IPInvestigation): Observable<IPInvestigation[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:IPInvestigation): Observable<IPInvestigation> {
      return this.api.update(url,data);
    }
     
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  